import React from 'react';
import { FormattedMessage } from 'react-intl';
import './Footer.scss';
import facebookIcon from '../../../../client_customizations/assets/images/icons/facebook-icon.png';
import instagramIcon from '../../../../client_customizations/assets/images/icons/instagram-icon.png';
import linkedinIcon from '../../../../client_customizations/assets/images/icons/linkedin-icon.png';
import twitterIcon from '../../../../client_customizations/assets/images/icons/twitter-icon.jpg';
import youtubeIcon from '../../../../client_customizations/assets/images/icons/youtube-icon.png';
import DisclaimerLogo from '../../../../client_customizations/assets/images/zappyride-logo.svg';

const Footer = ({ language }) => {
  return (
    <div className="Footer">
      <div className="container pt-5 pb-4">
        <div className="footer-grid">
          <div className="footer-col">
            <h3 className="footer-heading">
              <FormattedMessage
                id="footer.customerServices"
                defaultMessage="Customer Services"
              />
            </h3>
            <p className="footer-contact">
              <FormattedMessage
                id="footer.phoneMain"
                defaultMessage="512-494-9400"
              />
              <br />
              <br />
              <FormattedMessage
                id="footer.outsideAustin"
                defaultMessage="Outside Austin call toll-free:"
              />
              <br />
              <FormattedMessage
                id="footer.phoneTollFree"
                defaultMessage="888-340-6465"
              />
            </p>

            <ul className="footer-list">
              <li>
                <a href="/about/company-profile/directory">
                  <FormattedMessage
                    id="footer.contactUs"
                    defaultMessage="Contact Us"
                  />
                </a>
              </li>
              <li>
                <a
                  href="mailto:pluginaustin@austinenergy.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline"
                >
                  <FormattedMessage
                    id="footer.pluginAustinEmail"
                    defaultMessage="pluginaustin@austinenergy.com"
                  />
                </a>
              </li>
              <li>
                <a
                  href="http://pluginaustin.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="footer.pluginAustinWebsite"
                    defaultMessage="Pluginaustin.com"
                  />
                </a>
              </li>
            </ul>

            <h4 className="footer-subheading">
              <FormattedMessage
                id="footer.disabilityAssist"
                defaultMessage="Disability Assistance"
              />
            </h4>
            <p className="footer-contact">
              <FormattedMessage
                id="footer.vrsCalls"
                defaultMessage="VRS calls are accepted"
              />
            </p>
            <ul className="footer-list">
              <li>
                <a
                  href="https://www.austintexas.gov/page/americans-disabilities-act-ada"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="footer.requestAccommodations"
                    defaultMessage="Request Accommodations"
                  />
                </a>
              </li>
            </ul>

            <h4 className="footer-subheading">
              <FormattedMessage
                id="footer.reportOutages"
                defaultMessage="Report Outages"
              />
            </h4>
            <p className="footer-contact">
              <FormattedMessage
                id="footer.outagePhone"
                defaultMessage="512-322-9100"
              />
            </p>
            <ul className="footer-list">
              <li>
                <a
                  href="https://outagemap.austinenergy.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="footer.viewOutages"
                    defaultMessage="View Outages Online"
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://austinenergy.ifactornotifi.com/ui/outage-reporting/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="footer.reportOutage"
                    defaultMessage="Report Outage & View Status"
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://austinenergy.com/outages/report-outages/outage-alerts"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="footer.outageAlerts"
                    defaultMessage="Outage Alerts"
                  />
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h3 className="footer-heading">
              <FormattedMessage
                id="footer.renewableEnergy"
                defaultMessage="Renewable Energy"
              />
            </h3>
            <ul className="footer-list">
              <li>
                <a
                  href="https://austinenergy.com/green-power/greenchoice"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="footer.greenChoice"
                    defaultMessage="GreenChoice® Wind Energy"
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://austinenergy.com/green-power/solar-solutions/solar-solutions"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="footer.solar"
                    defaultMessage="Solar for Home or Business"
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://austinenergy.com/green-power/plug-in-austin"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="footer.electricVehicles"
                    defaultMessage="Electric Vehicles"
                  />
                </a>
              </li>
            </ul>

            <h3 className="footer-heading">
              <FormattedMessage
                id="footer.helpHighBills"
                defaultMessage="Help With High Bills"
              />
            </h3>
            <ul className="footer-list">
              <li>
                <a
                  href="https://savings.austinenergy.com/residential/learn/monitor-your-usage/res-app"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="footer.manageEnergy"
                    defaultMessage="Manage Your Energy Costs"
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://coautilities.com/wps/wcm/connect/occ/coa/util/support/customer-assistance"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="footer.customerAssistPrograms"
                    defaultMessage="Customer Assistance Programs"
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://savings.austinenergy.com/residential/offerings/home-improvements/weatherization"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="footer.weatherization"
                    defaultMessage="Weatherization Assistance"
                  />
                </a>
              </li>
            </ul>

            <h3 className="footer-heading">
              <FormattedMessage
                id="footer.energyEfficiency"
                defaultMessage="Energy Efficiency"
              />
            </h3>
            <ul className="footer-list">
              <li>
                <a
                  href="https://savings.austinenergy.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="footer.rebates"
                    defaultMessage="Rebates & Incentives"
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://austinenergy.com/energy-efficiency/green-building"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="footer.greenBuilding"
                    defaultMessage="Green Building"
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://austinenergy.com/energy-efficiency/ecad-ordinance/energy-conservation-audit-and-disclosure-ordinance"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="footer.ecad"
                    defaultMessage="ECAD Ordinance & Energy Audits"
                  />
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h3 className="footer-heading">
              <FormattedMessage
                id="footer.spotlight"
                defaultMessage="In the Spotlight"
              />
            </h3>
            <ul className="footer-list">
              <li>
                <a
                  href="https://coautilities.com/wps/wcm/connect/occ/coa/util/news/aun"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="footer.austinUtilitiesNow"
                    defaultMessage="Austin Utilities Now"
                  />
                </a>
              </li>
            </ul>

            <h3 className="footer-heading">
              <FormattedMessage
                id="footer.aboutAE"
                defaultMessage="About Austin Energy"
              />
            </h3>
            <ul className="footer-list">
              <li>
                <a
                  href="https://austinenergy.com/about/company-profile"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="footer.whoWeAre"
                    defaultMessage="Who we are"
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://austinenergy.com/about/history"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="footer.history"
                    defaultMessage="Our History"
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://austinenergy.com/about/reports"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="footer.reports"
                    defaultMessage="Corporate Reports"
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://austinenergy.com/about/news"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage id="footer.news" defaultMessage="News" />
                </a>
              </li>
              <li>
                <a
                  href="https://austinenergy.com/about/careers"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="footer.careers"
                    defaultMessage="Careers"
                  />
                </a>
              </li>
            </ul>

            <h3 className="footer-heading">
              <FormattedMessage
                id="footer.electricRates"
                defaultMessage="Electric Rates"
              />
            </h3>
            <ul className="footer-list">
              <li>
                <a
                  href="https://austinenergy.com/rates/residential-rates/residential-electric-rates-and-line-items"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="footer.residentialRates"
                    defaultMessage="Residential Rates"
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://austinenergy.com/rates/commercial-rates/commercial-electric-rates-and-line-items"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="footer.commercialRates"
                    defaultMessage="Commercial Rates"
                  />
                </a>
              </li>
            </ul>

            <h3 className="footer-heading">
              <FormattedMessage
                id="footer.initiatives"
                defaultMessage="Initiatives & Outreach"
              />
            </h3>
            <ul className="footer-list">
              <li>
                <a
                  href="https://austinenergy.com/about/company-profile/environment"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="footer.environment"
                    defaultMessage="Environment"
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://austinenergy.com/about/community-outreach/community-outreach"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="footer.communitySchools"
                    defaultMessage="Community & Schools"
                  />
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h3 className="footer-heading">
              <FormattedMessage id="footer.safety" defaultMessage="Safety" />
            </h3>
            <ul className="footer-list">
              <li>
                <a
                  href="https://austinenergy.com/commercial/commercial-services/call-before-you-dig"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="footer.callBeforeDig"
                    defaultMessage="Call 8-1-1 Before You Dig"
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://austinenergy.com/about/electrical-safety"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="footer.electricalSafety"
                    defaultMessage="Electrical Safety"
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://austinenergy.com/outages/report-outages/what-to-do-during-an-outage"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="footer.safetyDuringOutage"
                    defaultMessage="Safety During Outages"
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://austinenergy.com/residential/residential-services/tree-trimming"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="footer.treeTrimming"
                    defaultMessage="Tree Trimming Services"
                  />
                </a>
              </li>
            </ul>

            <h3 className="footer-heading">
              <FormattedMessage
                id="footer.commercialIndustrial"
                defaultMessage="Commercial & Industrial"
              />
            </h3>
            <ul className="footer-list">
              <li>
                <a
                  href="https://savings.austinenergy.com/commercial/learn/manage-your-usage/com-app"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="footer.commercialApp"
                    defaultMessage="Commercial Web App"
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://coautilities.com/wps/wcm/connect/occ/coa/util/support/utility-service/mpp"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="footer.multifamilyProgram"
                    defaultMessage="Multifamily Partnership Program"
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://austinenergy.com/commercial/commercial-services/district-energy-cooling/district-energy-cooling"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="footer.districtEnergy"
                    defaultMessage="District Energy & Cooling"
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://savings.austinenergy.com/commercial/learn/manage-your-usage/energy-profiler-online"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="footer.energyProfiler"
                    defaultMessage="Energy Profiler Online"
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://austinenergy.com/contractors/construction-renovation/design-reference-and-process-documentation"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="footer.electricDesignCriteria"
                    defaultMessage="Electric Design Criteria & ESPA"
                  />
                </a>
              </li>
            </ul>

            <div className="socials">
              <p className="footer-heading">
                <FormattedMessage
                  id="footer.followUs"
                  defaultMessage="Follow Us"
                />
              </p>
              <ul className="socials-list">
                <li>
                  <a
                    href="https://www.facebook.com/austinenergy"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Facebook"
                  >
                    <img
                      src={facebookIcon}
                      alt="Facebook"
                      width="30"
                      height="30"
                    />
                  </a>
                </li>
                <li>
                  <a
                    href="https://twitter.com/austinenergy"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="X (Twitter)"
                  >
                    <img src={twitterIcon} alt="X" width="30" height="30" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/user/AustinEnergyVideos"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="YouTube"
                  >
                    <img
                      src={youtubeIcon}
                      alt="YouTube"
                      width="30"
                      height="30"
                    />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/company/austin-energy"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="LinkedIn"
                  >
                    <img
                      src={linkedinIcon}
                      alt="LinkedIn"
                      width="31"
                      height="31"
                    />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/austinenergy/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Instagram"
                  >
                    <img
                      src={instagramIcon}
                      alt="Instagram"
                      width="30"
                      height="30"
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="disclaimer-container">
          {language === 'ES' ? (
            <div className="disclaimer-image">
              <p>
                Soluciones de vehículos eléctricos ofrecidas por ZappyRide, una
                empresa de J.D. Power.
              </p>
            </div>
          ) : (
            <img src={DisclaimerLogo} alt="Disclaimer Logo" />
          )}
          <p>
            <FormattedMessage
              id="footer.disclaimerText"
              defaultMessage="Figures shown on this page are estimates based on data provided by third-parties. This material is provided for informational purposes only and should not be relied on for tax, legal, or financial advice. Neither ZappyRide® nor J.D. Power® provides tax, legal or financial advice. You should independently verify the estimates provided here before engaging in any transaction."
            />
          </p>
        </div>
      </div>

      <div className="container-fluid" style={{ backgroundColor: '#44499C' }}>
        <div className="container" style={{ padding: '10px' }}>
          <p
            style={{
              marginBottom: 0,
              color: '#fff',
              fontSize: '11px',
              textAlign: 'center',
            }}
          >
            <span style={{ fontFamily: 'Arial, Helvetica' }}>&copy;</span>
            {new Date().getFullYear().toString()}{' '}
            {process.env.REACT_APP_FULL_COMPANY_NAME}.{' '}
            <FormattedMessage
              id="footer.allRights"
              defaultMessage="All Rights Reserved."
            />
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
